import React, { useEffect, useState } from "react";
import "../assets/css/ShipmentDetails.css";
import axios from "axios";

const Inquiry = () => {
  const [complaintType, setComplaintType] = useState([]);
  const [formData, setFormData] = useState({
    TypeID: "2",
    Email: "",
    Telephone: "",
    Details: "",
    AWB: "",
    Subject: "",
  });

  useEffect(() => {
    const userData = JSON.parse(localStorage.getItem("userData"));
    // جلب أنواع الطلبات من API
    axios
      .get("https://tarabotcs.com-eg.net/api/Agent/V1/V1GetTiketTypes", {
        headers: {
          CompanyID: userData.Data.CompanyID,
          AccessToken: userData.Data.AccessToken,
        },
      })
      .then((response) => {
        if (response.data && response.data.Data) {
          setComplaintType(response.data.Data); // استخدام فقط مصفوفة Data
        } else {
          setComplaintType([]);
        }
      })
      .catch((error) => {
        console.error("Error fetching ticket types:", error);
        setComplaintType([]); // في حالة الخطأ قم بتحديد مصفوفة فارغة
      });
  }, []);

  const handleInputChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    const userData = JSON.parse(localStorage.getItem("userData"));
    e.preventDefault();
    axios
      .post("https://tarabotcs.com-eg.net/api/Agent/V1/AddTicket", formData, {
        headers: {
          CompanyID: userData.Data.CompanyID,
          AccessToken: userData.Data.AccessToken,
        },
      })
      .then((response) => {
        alert("Complaint submitted successfully!");
      })
      .catch((error) => {
        console.error("Error submitting complaint:", error);
        alert("Failed to submit complaint.");
      });
  };

  return (
    <div className="details-page">
      <div className="complaint-container">
        <div className="complaint-header">New Inquiry</div>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Phone</label>
            <input
              type="text"
              name="Telephone"
              value={formData.Telephone}
              onChange={handleInputChange}
              required
            />
          </div>

          <div className="form-group">
            <label>Email</label>
            <input
              type="email"
              name="Email"
              value={formData.Email}
              onChange={handleInputChange}
              required
            />
          </div>

          <div className="form-group">
            <label>Subject</label>
            <input
              type="text"
              name="Subject"
              value={formData.Subject}
              onChange={handleInputChange}
              required
            />
          </div>

          <div className="form-group">
            <label>Details</label>
            <textarea
              name="Details"
              value={formData.Details}
              onChange={handleInputChange}
              required
            />
          </div>

          <button type="submit" className="btn-submit">
            Save
          </button>
        </form>
      </div>
    </div>
  );
};

export default Inquiry;
